import request from '@/config'
import { AttachmentDetail, CreateDocDto } from './attachment.type'

/* 创建文档 */
export const CreateDocApi = (docData: CreateDocDto): Promise<IResponse> => {

    return request.post({ url: '/api/onlyofficeapi/createdoc', data: docData })
}


/* 获取某个合同附件(列表) */
export const GetAttachmentList = (ctId: string): Promise<IResponse> => {

    const searchDto = {
        current: 1,
        page_size: 99,
        tenant_id: 1,
        type_id: ctId,
    };

    return request.post({ url: '/api/Attachment/GetAttachmentPage', data: searchDto })
}


/* 附件：删除某个附件(列表) */
export const DelAttachmentApi = (rowId: string): Promise<IResponse> => {

    const deleteDto = {
        tenant_id: '1',
        revision: '0',
        deleted_user_id: '1',
        id: rowId,
    };

    return request.post({ url: '/api/Attachment/DeleteAttachment', data: deleteDto })
}

/* 附件：获取文档页面JS配置参数(JS Version) */
export const GetDocConfigApi = (fileId: string, action: string): Promise<IResponse> => {

    const searchDto = {
        fileId: fileId,
        version: '',
        action: action || 'view',
    };

    return request.post({ url: '/api/OnlyOfficeApi/GetDocumentConfig', data: searchDto })
}


export const GetDocHistoryApi = (fileId: string): Promise<IResponse> => {

    return request.post({ url: '/api/OnlyOfficeApi/GetDocHistory', data: { fileId: fileId } })

}

export const GetReducingApi = (fileId: string, version: string): Promise<IResponse> => {

    return request.post({ url: '/api/OnlyOfficeApi/GetReducingInfo', data: { fileId: fileId, version: version } })

}

export const GetDocDiffApi = (fileId: string, version: string): Promise<IResponse> => {

    return request.post({ url: '/api/onlyofficeapi/getdoceditdiff', data: { fileId: fileId, version: version } })

}







